import { FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../../Services/LondunarkerfiAPIService';
import axios from 'axios';
import { Alert, Box, Button } from '@mui/material';

const NotFound: FC = () => {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  
  useEffect(() => {
    const handleLoginChange = async () => {
      try {
        const userData = await getUser();
        if (userData && userData.isReweighingUser) {
          navigate('/reweighting');
        } else {
          navigate('/landings');
        }
      } catch (error) {
        if (axios.isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) {
          navigate('/unauthorized', { replace: true });
        } else {
          setFailed(true);
        }
      }
    }
    handleLoginChange();
  }, [navigate]);

  return failed ? <Box sx={{ p: 3 }}>
    <Alert severity="error">Ekki tókst að sækja aðgangsupplýsingar.</Alert>
    <Button onClick={() => navigate('/landings')} sx={{ mt: 2 }}>Reyna aftur</Button>
  </Box> : null;
};

export default NotFound;
